// Create chatbot UI dynamically
const chatbotBox = document.createElement("div");
chatbotBox.id = "chatbot-box";

// Chatbot size configuration
const CHATBOT_CONFIG = {
  width: 350,
  defaultHeight: 600, // Start at max height
  minHeight: 450,
  maxHeight: 675,
  currentHeight: 600 // Start at max heigh
};

chatbotBox.style = `
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: ${CHATBOT_CONFIG.width}px;
  height: ${CHATBOT_CONFIG.currentHeight}px;
  background: #ffffff;
  border: none;
  border-radius: 16px;
  display: none;
  flex-direction: column;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  z-index: 9999;
  overflow: hidden;
  resize: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

chatbotBox.innerHTML = `
  <div id="resize-handle" style="
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 8px;
    cursor: ns-resize;
    background: transparent;
    z-index: 10;
    border-radius: 16px 16px 0 0;
  "></div>
  <div style="
    background: linear-gradient(to right, #1f2937, #111827);
    color: white;
    padding: 10px 16px;
    border-radius: 16px 16px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  ">
    <div style="display: flex; align-items: center; gap: 10px;">
      <svg viewBox="0 0 200 200" style="width: 32px; height: 32px; flex-shrink: 0;">
        <circle cx="100" cy="100" r="100" fill="#FF7B66"/>
        <path d="M 100,20 Q 105,50 100,80 Q 95,50 100,20" fill="#EE88FF"/>
        <path d="M 130,25 Q 125,55 110,75 Q 115,50 130,25" fill="#EE88FF"/>
        <path d="M 155,45 Q 140,65 120,75 Q 130,60 155,45" fill="#EE88FF"/>
        <path d="M 175,70 Q 150,75 125,80 Q 140,70 175,70" fill="#EE88FF"/>
        <path d="M 180,100 Q 150,100 125,100 Q 145,95 180,100" fill="#EE88FF"/>
        <path d="M 175,130 Q 150,125 125,120 Q 140,125 175,130" fill="#EE88FF"/>
        <path d="M 155,155 Q 140,135 120,125 Q 130,140 155,155" fill="#EE88FF"/>
        <path d="M 130,175 Q 125,145 110,125 Q 115,150 130,175" fill="#EE88FF"/>
        <path d="M 100,180 Q 105,150 100,120 Q 95,150 100,180" fill="#EE88FF"/>
        <path d="M 70,175 Q 75,145 90,125 Q 85,150 70,175" fill="#EE88FF"/>
        <path d="M 45,155 Q 60,135 80,125 Q 70,140 45,155" fill="#EE88FF"/>
        <path d="M 25,130 Q 50,125 75,120 Q 60,125 25,130" fill="#EE88FF"/>
        <path d="M 20,100 Q 50,100 75,100 Q 55,95 20,100" fill="#EE88FF"/>
        <path d="M 25,70 Q 50,75 75,80 Q 60,70 25,70" fill="#EE88FF"/>
        <path d="M 45,45 Q 60,65 80,75 Q 70,60 45,45" fill="#EE88FF"/>
        <path d="M 70,25 Q 75,55 90,75 Q 85,50 70,25" fill="#EE88FF"/>
        <circle cx="100" cy="100" r="45" fill="#EE88FF"/>
        <text x="100" y="120" font-family="Arial Black, sans-serif" font-size="48" font-weight="900" fill="black" text-anchor="middle">GLOW</text>
      </svg>
      <div>
        <span style="font-weight: 700; font-size: 16px; letter-spacing: 0.5px; display: block; font-family: var(--chatbot-header-font); text-transform: uppercase;">GLOW LIVE CHAT</span>
        <div style="display: flex; align-items: center; gap: 6px; margin-top: 1px;">
          <div style="width: 8px; height: 8px; background: #10b981; border-radius: 50%; box-shadow: 0 0 6px rgba(16, 185, 129, 0.65); border: 1px solid rgba(255,255,255,0.35); flex-shrink: 0;"></div>
          <span style="font-size: 10px; color: #d1d5db; position: relative; top: -2px;">Online</span>
        </div>
      </div>
    </div>
    <span style="
      cursor: pointer;
      padding: 8px;
      border-radius: 50%;
      transition: background-color 0.3s ease;
      font-size: 24px;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      opacity: 0.7;
    " 
    onclick="closeChatbot()"
    onmouseover="this.style.backgroundColor='rgba(255,255,255,0.1)'; this.style.opacity='1'"
    onmouseout="this.style.backgroundColor='transparent'; this.style.opacity='0.7'">×</span>
  </div>
  <div id="chatbot-messages" style="
    flex: 1;
    padding: 16px;
    overflow-y: auto;
    font-size: 12px;
    line-height: 1.4;
    background: linear-gradient(to bottom, #ffffff 0%, #f9fafb 100%);
  "></div>
  <div id="chatbot-input-area" style="
    padding: 10px 16px;
    background: white;
    border-top: 1px solid #e5e7eb;
    border-radius: 0 0 16px 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  ">
    <div id="chatbot-user-row" style="
      display: flex;
      gap: 10px;
      align-items: center;
      flex-wrap: wrap;
    ">
      <input id="chatbot-user-name" type="text" placeholder="Name"
        style="
          border: 1px solid #d1d5db;
          border-radius: 12px;
          padding: 10px 12px;
          flex: 1 1 140px;
          min-width: 120px;
          outline: none;
          font-size: 13px;
          font-family: inherit;
          transition: all 0.3s ease;
          background: white;
        "
        onfocus="this.style.borderColor='#f472b6'; this.style.boxShadow='0 0 0 3px rgba(244, 114, 182, 0.1)'"
        onblur="this.style.borderColor='#d1d5db'; this.style.boxShadow='none'">
      <input id="chatbot-user-email" type="email" placeholder="Email"
        style="
          border: 1px solid #d1d5db;
          border-radius: 12px;
          padding: 10px 12px;
          flex: 1 1 160px;
          min-width: 140px;
          outline: none;
          font-size: 13px;
          font-family: inherit;
          transition: all 0.3s ease;
          background: white;
        "
        onfocus="this.style.borderColor='#f472b6'; this.style.boxShadow='0 0 0 3px rgba(244, 114, 182, 0.1)'"
        onblur="this.style.borderColor='#d1d5db'; this.style.boxShadow='none'">
    </div>
    <div id="chatbot-user-error" style="
      display: none;
      color: rgba(220, 38, 38, 0.9);
      font-size: 12px;
      line-height: 1.3;
      margin-top: -4px;
    "></div>
    <div id="chatbot-message-row" style="
      display: flex;
      gap: 12px;
      align-items: center;
      background: #f9fafb;
      padding: 8px;
      border-radius: 9999px;
      border: 3px solid #000000;
    ">
      <input id="chatbot-input" type="text" placeholder="Escribe tu mensaje..."
        style="
          border: none;
          padding: 6px 12px;
          flex: 1;
          outline: none;
          font-size: 14px;
          font-family: inherit;
          background: transparent;
          color: #1f2937;
        ">
      <button id="send-button" disabled style="
        background: #e5e7eb;
        border: none;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: not-allowed;
        transition: all 0.3s ease;
        color: #9ca3af;
        font-size: 18px;
        flex-shrink: 0;
      " 
      onmouseover="if (!this.disabled) { this.style.background='linear-gradient(to right, #f472b6, #fb923c)'; this.style.color='white'; }"
      onmouseout="if (!this.disabled) { this.style.background='linear-gradient(to right, #f472b6, #fb923c)'; this.style.color='white'; } else { this.style.background='#e5e7eb'; this.style.color='#9ca3af'; }"
      onclick="if (!this.disabled) sendMessage()">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="22" y1="2" x2="11" y2="13"></line>
          <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
        </svg>
      </button>
    </div>
    <p style="text-align: center; font-size: 9px; color: #9ca3af; margin: 2px 0 0 0;">⚡️ by Hey Bruno</p>
  </div>
`;

// Add CSS animations and modern styling
const style = document.createElement('style');
style.textContent = `
  
  @keyframes gentleFloat {
    0%, 100% { transform: translateY(0px) scale(1); }
    50% { transform: translateY(-2px) scale(1.02); }
  }
  
  @keyframes shakeAttention {
    0%, 100% { transform: translateX(0) scale(1); }
    10%, 30%, 50%, 70%, 90% { transform: translateX(-3px) scale(1.02); }
    20%, 40%, 60%, 80% { transform: translateX(3px) scale(1.02); }
  }
  
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes fadeSlideIn {
    0% { 
      transform: translateY(10px) scale(0.95);
      opacity: 0;
    }
    100% {
      transform: translateY(0) scale(1);
      opacity: 1;
    }
  }
  
  @keyframes fadeSlideOut {
    0% {
      transform: translateY(0) scale(1);
      opacity: 1;
    }
    100% {
      transform: translateY(10px) scale(0.95);
      opacity: 0;
    }
  }
  
  @keyframes slideInFromLeft {
    0% {
      transform: translateX(-20px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  @keyframes slideOutToLeft {
    0% {
      transform: translateX(0);
      opacity: 1;
    }
    100% {
      transform: translateX(-20px);
      opacity: 0;
    }
  }
  
  
  .professional-appear {
    animation: fadeSlideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  }
  
  .professional-disappear {
    animation: fadeSlideOut 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  }
  
  /* Modern scrollbar styling */
  #chatbot-messages::-webkit-scrollbar {
    width: 3px;
  }
  
  #chatbot-messages::-webkit-scrollbar-track {
    background: transparent;
  }
  
  #chatbot-messages::-webkit-scrollbar-thumb {
    background: rgba(244, 114, 182, 0.3);
    border-radius: 2px;
  }
  
  #chatbot-messages::-webkit-scrollbar-thumb:hover {
    background: rgba(244, 114, 182, 0.5);
  }
  
  /* Firefox scrollbar */
  #chatbot-messages {
    scrollbar-width: thin;
    scrollbar-color: rgba(244, 114, 182, 0.3) transparent;
  }
  
  /* Text formatting styles */
  .product-name {
    color: #f472b6;
    font-weight: 600;
    font-size: 15px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    margin: 8px 0 4px 0;
    display: block;
  }
  
  .benefit-item {
    color: #1f2937;
    font-weight: normal;
    margin: 3px 0 3px 0;
    padding-left: 0;
    line-height: 1.4;
  }
  
  .numbered-list-item, .bullet-list-item {
    display: flex;
    align-items: flex-start;
    margin: 4px 0 4px 0;
    line-height: 1.4;
  }
  
  .list-number, .bullet {
    color: #f472b6;
    font-weight: 600;
    margin-right: 6px;
    min-width: auto;
    flex-shrink: 0;
  }
  
  .ai-message strong {
    color: #f472b6;
    font-weight: 600;
  }
  
  .ai-message em {
    color: #fb923c;
    font-style: italic;
  }
  
  .ai-message h3 {
    color: #f472b6;
    font-weight: 600;
    font-size: 16px;
    margin: 12px 0 8px 0;
    border-bottom: 2px solid rgba(244, 114, 182, 0.2);
    padding-bottom: 4px;
  }
  
  .ai-message p {
    margin: 8px 0;
    line-height: 1.5;
  }
  
  .ai-message ul, .ai-message ol {
    margin: 8px 0;
    padding-left: 0;
  }
  
  .ai-message li {
    margin: 4px 0;
    list-style: none;
  }
  
  .ai-message a {
    color: #f472b6 !important;
    text-decoration: underline !important;
    transition: color 0.2s ease;
    word-break: break-word;
    cursor: pointer !important;
    pointer-events: auto !important;
    font-weight: 500 !important;
  }

  .ai-message a.glow-link,
  .streaming-content a.glow-link {
    color: #f472b6 !important;
    text-decoration: underline !important;
    cursor: pointer !important;
    pointer-events: auto !important;
    font-weight: 500 !important;
  }
  
  .ai-message a:hover {
    color: #fb923c !important;
    text-decoration: underline !important;
  }
  
  .ai-message img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin: 8px 0;
    display: block;
  }
  
  /* Streaming animation styles */
  .streaming-content {
    display: inline;
  }
  
  .streaming-content a {
    color: #f472b6 !important;
    text-decoration: underline !important;
    cursor: pointer !important;
    pointer-events: auto !important;
    font-weight: 500 !important;
  }
  
  .streaming-content a:hover {
    color: #fb923c !important;
  }
  
  .streaming-dots {
    display: inline-flex;
    align-items: center;
  }
  
  @keyframes text-appear {
    0% { opacity: 0; transform: translateY(2px); }
    100% { opacity: 1; transform: translateY(0); }
  }
  
  .streaming .streaming-content {
    animation: text-appear 0.3s ease-out;
  }

  /* Product cards shown below AI message */
  .product-cards-wrapper {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 12px;
    width: 100%;
  }
  
  .product-cards {
    margin-top: 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    max-width: 75%;
  }
  
  .product-card-new {
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(244, 114, 182, 0.2);
    overflow: hidden;
    transition: all 0.3s ease;
  }
  
  .product-buy-btn {
    transition: all 0.2s ease;
  }
  
  .product-buy-btn:active {
    transform: scale(0.95) !important;
  }
  
  /* Legacy product card styles (keep for backwards compatibility) */
  .product-card {
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 10px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.85);
    border: 1px solid rgba(244, 114, 182, 0.18);
    text-decoration: none;
    color: inherit;
    transition: all 0.2s ease;
  }
  .product-card:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(244, 114, 182, 0.18), 0 2px 8px rgba(0,0,0,0.08);
  }
  .product-card-img, .product-card-img img {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    flex-shrink: 0;
  }
  .product-card-img {
    background: linear-gradient(135deg, rgba(244, 114, 182, 0.18) 0%, rgba(251, 146, 60, 0.12) 100%);
    border: 1px solid rgba(244, 114, 182, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .product-card-img img {
    object-fit: cover;
    display: block;
  }
  .product-card-title {
    font-weight: 600;
    font-size: 13px;
    color: rgba(30, 41, 59, 0.95);
    line-height: 1.2;
  }
  .product-card-subtitle {
    font-size: 12px;
    color: rgba(100, 116, 139, 0.9);
    line-height: 1.2;
    margin-top: 2px;
  }

  /* Star rating widget */
  .star-rating {
    margin-top: 12px;
    padding-top: 10px;
    border-top: 1px solid rgba(244, 114, 182, 0.15);
  }
  .star-row {
    display: inline-flex;
    gap: 6px;
    align-items: center;
  }
  .star {
    width: 26px;
    height: 26px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 9999px;
    border: 1px solid rgba(244, 114, 182, 0.25);
    background: rgba(255, 255, 255, 0.75);
    cursor: pointer;
    user-select: none;
    transition: all 0.15s ease;
    color: rgba(244, 114, 182, 0.55);
    font-size: 14px;
  }
  .star:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(244, 114, 182, 0.18);
  }
  .star.active {
    background: linear-gradient(to right, #f472b6, #fb923c);
    color: white;
    border-color: transparent;
  }
  .star-hint {
    margin-top: 8px;
    font-size: 12px;
    color: rgba(100, 116, 139, 0.9);
  }

  /* Order tracking widget */
  .order-widget {
    margin-top: 12px;
    padding-top: 10px;
    border-top: 1px solid rgba(244, 114, 182, 0.15);
  }
  .order-widget-title {
    font-weight: 600;
    color: #f472b6;
    font-size: 13px;
  }
  .order-widget-row {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 8px;
    align-items: center;
  }
  .order-widget-row input {
    border: 1px solid rgba(244, 114, 182, 0.25);
    border-radius: 10px;
    padding: 10px 12px;
    font-size: 13px;
    outline: none;
    background: rgba(255,255,255,0.9);
    flex: 1 1 160px;
    min-width: 140px;
  }
  .order-widget-row input:focus {
    border-color: #f472b6;
    box-shadow: 0 0 0 3px rgba(244, 114, 182, 0.1);
  }
  .order-widget-row button {
    background: linear-gradient(to right, #f472b6, #fb923c);
    border: none;
    color: white;
    border-radius: 10px;
    padding: 10px 12px;
    cursor: pointer;
    font-size: 13px;
    transition: all 0.2s ease;
    white-space: nowrap;
  }
  .order-widget-row button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  .order-widget-msg {
    margin-top: 8px;
    font-size: 12px;
    color: rgba(100, 116, 139, 0.9);
  }
  
  .product-section {
    margin: 12px 0;
    padding: 8px 0;
    border-left: 3px solid rgba(244, 114, 182, 0.3);
    padding-left: 12px;
  }
  
  .usage-instruction {
    background: rgba(244, 114, 182, 0.1);
    border-radius: 8px;
    padding: 8px 12px;
    margin: 8px 0;
    font-weight: 500;
    color: #f472b6;
  }
  
  /* GLOW chatbot button styles - removed old Mila styles */

  /* Mobile responsiveness */
  @media (max-width: 768px) {
    .glow-chatbot-button {
      width: 60px !important;
      height: 60px !important;
      bottom: 15px !important;
      right: 15px !important;
    }
    
    #chatbot-box {
      width: 90vw !important;
      max-width: 350px;
      height: 60vh !important; /* half-ish on tablets */
      max-height: 600px;
      right: 5vw !important;
      bottom: 5vw !important;
    }
    
    #chatbot-messages {
      padding: 15px !important;
      font-size: 13px !important;
    }
    
    .help-bubble {
      right: 20px !important;
      font-size: 8px !important;
      padding: 3px 6px !important;
      border-radius: 6px !important;
    }
    
    .help-bubble:nth-child(1) {
      bottom: 95px !important;
    }
    
    .help-bubble:nth-child(2) {
      bottom: 100px !important;
    }
    
    .help-bubble:nth-child(3) {
      bottom: 65px !important;
    }
    
    /* Product cards responsive for tablets */
    .product-cards {
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
      max-width: 85%;
    }
    
    .product-card-new {
      border-radius: 14px;
    }
    
    .product-buy-btn {
      padding: 10px 14px;
      font-size: 13px;
    }
  }

  @media (max-width: 480px) {
    .glow-chatbot-button {
      width: 55px !important;
      height: 55px !important;
      bottom: 10px !important;
      right: 10px !important;
    }
    
    #chatbot-box {
      width: 95vw !important;
      height: 55vh !important; /* half-ish screen on phones */
      right: 2.5vw !important;
      bottom: 2.5vw !important;
      max-height: none !important;
    }
    
    #chatbot-messages {
      padding: 12px !important;
      font-size: 12px !important;
    }
    
    #chatbot-input {
      font-size: 14px !important;
      padding: 10px 14px !important;
    }
    
    #send-button {
      width: 35px !important;
      height: 35px !important;
      font-size: 14px !important;
    }
    
    .help-bubble {
      right: 15px !important;
      font-size: 7px !important;
      padding: 2px 5px !important;
      border-radius: 5px !important;
    }
    
    .help-bubble:nth-child(1) {
      bottom: 80px !important;
    }
    
    .help-bubble:nth-child(2) {
      bottom: 67px !important;
    }
    
    .help-bubble:nth-child(3) {
      bottom: 54px !important;
    }
    
    /* Product cards stack on mobile phones */
    .product-cards {
      grid-template-columns: 1fr;
      gap: 10px;
      max-width: 90%;
    }
    
    .product-card-new {
      border-radius: 12px;
    }
    
    .product-buy-btn {
      padding: 12px 16px;
      font-size: 14px;
    }
  }
  
  @media (max-width: 320px) {
    .glow-chatbot-button {
      width: 50px !important;
      height: 50px !important;
    }
    
    #chatbot-box {
      width: 98vw !important;
      height: 85vh !important;
      right: 1vw !important;
      bottom: 1vw !important;
    }
    
    .help-bubble {
      right: 12px !important;
      font-size: 6px !important;
      padding: 2px 4px !important;
      border-radius: 4px !important;
    }
    
    .help-bubble:nth-child(1) {
      bottom: 70px !important;
    }
    
    .help-bubble:nth-child(2) {
      bottom: 58px !important;
    }
    
    .help-bubble:nth-child(3) {
      bottom: 46px !important;
    }
  }

  /* Message bubble responsive styles */
  @media (max-width: 768px) {
    .user-message, .ai-message, .welcome-message {
      max-width: 85% !important;
      font-size: 13px !important;
      padding: 10px 14px !important;
      word-wrap: break-word !important;
      overflow-wrap: break-word !important;
      hyphens: auto !important;
    }
  }

  @media (max-width: 480px) {
    .user-message, .ai-message, .welcome-message {
      max-width: 90% !important;
      font-size: 12px !important;
      padding: 8px 12px !important;
      word-wrap: break-word !important;
      overflow-wrap: break-word !important;
      hyphens: auto !important;
      line-height: 1.3 !important;
    }
  }

  @media (max-width: 320px) {
    .user-message, .ai-message, .welcome-message {
      max-width: 95% !important;
      font-size: 11px !important;
      padding: 6px 10px !important;
    }
  }
  
  /* Enforce consistent text sizing between welcome and AI messages */
  .ai-message,
  .welcome-message,
  .user-message {
    font-size: 14px !important;
    line-height: 1.4 !important;
  }
  .ai-message *, .welcome-message *, .user-message * {
    font-size: inherit !important;
    line-height: inherit !important;
  }
  
  /* Feedback UI removed (replaced by star rating widget elsewhere) */
`;

document.head.appendChild(style);

// Add root CSS variables (header font is configurable)
if (!document.getElementById('chatbot-root-vars')) {
  const rootVars = document.createElement('style');
  rootVars.id = 'chatbot-root-vars';
  rootVars.textContent = `
    :root {
      --chatbot-header-font: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
    }
  `;
  document.head.appendChild(rootVars);
}

// Global wrapping fixes to prevent message overflow
if (!document.getElementById('chatbot-wrap-fixes')) {
  const wrapFix = document.createElement('style');
  wrapFix.id = 'chatbot-wrap-fixes';
  wrapFix.textContent = `
    .ai-message, .user-message, .welcome-message, .streaming .ai-message, .streaming-content {
      overflow-wrap: anywhere !important;
      word-break: break-word !important;
      white-space: normal !important;
      hyphens: auto !important;
    }
    .ai-message *, .user-message * {
      overflow-wrap: anywhere !important;
      word-break: break-word !important;
      white-space: normal !important;
      hyphens: auto !important;
    }
  `;
  document.head.appendChild(wrapFix);
}

document.body.appendChild(chatbotBox);

// Utility to change header font at runtime
function setHeaderFont(fontStack) {
  try {
    document.documentElement.style.setProperty('--chatbot-header-font', fontStack);
  } catch (_) { /* no-op */ }
}

// Global variables for chatbot state
let isChatbotOpen = false;
let helpBannerInterval;
let conversationHistory = [];
let hoverBannerTimeout;
let isHoverBannerVisible = false;
let isMouseOverMila = false;
let quickRepliesShown = false;

// User details and session tracking
let hasSubmittedUserDetails = false;
let userDetails = null;
let conversationId = null;

// Rating widget is only shown when backend returns end_of_conversation=true

function getOrCreateConversationId() {
  try {
    const existing = sessionStorage.getItem('glow_conversation_id');
    if (existing) return existing;
    const newId = 'conv_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
    sessionStorage.setItem('glow_conversation_id', newId);
    return newId;
  } catch (_) {
    return 'conv_' + Date.now();
  }
}

function hydrateUserDetails() {
  try {
    const raw = sessionStorage.getItem('glow_user_details');
    if (!raw) return;
    const parsed = JSON.parse(raw);
    if (parsed && parsed.name && parsed.email) {
      userDetails = parsed;
      hasSubmittedUserDetails = true;

      // Update UI immediately (hide details row after capture)
      const { rowEl, nameEl, emailEl } = getUserDetailsElements();
      if (nameEl) nameEl.value = parsed.name;
      if (emailEl) emailEl.value = parsed.email;
      if (rowEl) rowEl.style.display = 'none';
      clearUserDetailsError();
    }
  } catch (_) { /* no-op */ }
}

// Initialize session-scoped values
conversationId = getOrCreateConversationId();
hydrateUserDetails();

// API Configuration
const API_CONFIG = {
  endpoint: 'https://tptkr7hbze.execute-api.us-east-1.amazonaws.com/prod/chat', // Replace with your actual API Gateway endpoint
  timeout: 60000 // 60 seconds timeout
};

// Base system context to keep responses friendly and on-brand (backend contract unchanged)
const BASE_SYSTEM_CONTEXT = [
  'You are Glow bot, the friendly assistant for Glow Superfoods.',
  'Use a warm, friendly, and helpful tone. Be concise(very important), clear, and practical.',
  'If asked for medical advice, provide general information and encourage consulting a qualified professional.'
].join(' ');

// Add drag resize functionality
let isResizing = false;
let startY = 0;
let startHeight = 0;

function setupResizeHandle() {
  const resizeHandle = document.getElementById('resize-handle');
  
  resizeHandle.addEventListener('mousedown', function(e) {
    isResizing = true;
    startY = e.clientY;
    startHeight = CHATBOT_CONFIG.currentHeight;
    document.addEventListener('mousemove', handleResize);
    document.addEventListener('mouseup', stopResize);
    e.preventDefault();
  });
}

function handleResize(e) {
  if (!isResizing) return;
  
  const deltaY = startY - e.clientY; // Negative because we want to drag up to increase height
  const newHeight = Math.min(
    Math.max(startHeight + deltaY, CHATBOT_CONFIG.minHeight),
    CHATBOT_CONFIG.maxHeight
  );
  
  CHATBOT_CONFIG.currentHeight = newHeight;
  chatbotBox.style.height = newHeight + 'px';
}

function stopResize() {
  isResizing = false;
  document.removeEventListener('mousemove', handleResize);
  document.removeEventListener('mouseup', stopResize);
}

// Function to show quick reply buttons
function showQuickReplyButtons() {
  if (quickRepliesShown) return;
  quickRepliesShown = true;
  
  const chatbox = document.getElementById("chatbot-messages");
  const quickReplyContainer = document.createElement('div');
  quickReplyContainer.id = 'quick-reply-container';
  quickReplyContainer.style.cssText = 'display: flex; flex-wrap: wrap; gap: 12px; margin: 16px 0; animation: slideIn 0.4s ease-out;';
  
  const buttons = [
    { text: 'Your order', value: 'Your order' },
    { text: 'Our products', value: 'Our products' },
    { text: 'Our company', value: 'Our company' }
  ];
  
  buttons.forEach(button => {
    const btn = document.createElement('button');
    btn.textContent = button.text;
    btn.style.cssText = `
      padding: 10px 20px;
      border: 2px solid #f3b3c7;
      border-radius: 9999px;
      background: white;
      color: #1f2937;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s ease;
      box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    `;
    
    btn.onmouseover = () => {
      btn.style.borderColor = '#f472b6';
      btn.style.background = '#fef2f7';
      btn.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
    };
    
    btn.onmouseout = () => {
      btn.style.borderColor = '#f3b3c7';
      btn.style.background = 'white';
      btn.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
    };
    
    btn.onclick = () => {
      handleQuickReply(button.value);
    };
    
    quickReplyContainer.appendChild(btn);
  });
  
  chatbox.appendChild(quickReplyContainer);
  chatbox.scrollTop = chatbox.scrollHeight;
}

// Function to handle quick reply button clicks
function handleQuickReply(reply) {
  const input = document.getElementById("chatbot-input");
  input.value = reply;
  
  // Remove quick reply buttons
  const quickReplyContainer = document.getElementById('quick-reply-container');
  if (quickReplyContainer) {
    quickReplyContainer.remove();
  }
  
  // Send the message
  sendMessage();
}

// Close chatbot function
function closeChatbot() {
  isChatbotOpen = false;
  chatbotBox.classList.add('professional-disappear');
  
  setTimeout(() => {
    chatbotBox.style.display = 'none';
    chatbotBox.classList.remove('professional-disappear');
    openButton.classList.add('professional-appear');
    openButton.style.display = 'flex';
    
    // Start help banner
    startHelpBanner();
  }, 300);
}

// Help banner functionality (DISABLED - only shake animation is used now)
function createHelpBanner(isHover = false) {
  // Disabled - no longer showing help text bubbles
  return;
  
  const helpBannerContainer = document.createElement('div');
  helpBannerContainer.id = 'help-banner-container';
  if (isHover) {
    helpBannerContainer.classList.add('hover-banner');
  }
  
  const messages = ['Need help?', 'Glow bot here', 'Ask me anything'];
  const delays = [0, 300, 600]; // Staggered appearance
  
  messages.forEach((message, index) => {
    setTimeout(() => {
      const helpBubble = document.createElement('div');
      helpBubble.className = 'help-bubble';
      if (isHover) {
        helpBubble.classList.add('hover-bubble');
      }
      helpBubble.innerHTML = message;
      
      // Position all bubbles on top of Mila with responsive positioning
      const screenWidth = window.innerWidth;
      let bottomPos, rightPos;
      
      if (screenWidth <= 320) {
        bottomPos = 70 + (index * 16);
        rightPos = 12;
      } else if (screenWidth <= 480) {
        bottomPos = 80 + (index * 19);
        rightPos = 15;
      } else if (screenWidth <= 768) {
        bottomPos = 95 + (index * 22);
        rightPos = 20;
      } else {
        bottomPos = 115 + (index * 30);
        rightPos = 25;
      }
      
      helpBubble.style = `
        position: fixed;
        bottom: ${bottomPos}px;
        right: ${rightPos}px;
        background: linear-gradient(135deg, rgba(139, 69, 199, 0.95) 0%, rgba(91, 134, 229, 0.95) 100%);
        backdrop-filter: blur(15px);
        color: white;
        padding: 4px 8px;
        border-radius: 8px;
        font-size: 9px;
        font-weight: 500;
        box-shadow: 0 4px 12px rgba(139, 69, 199, 0.3), 0 2px 6px rgba(0, 0, 0, 0.1);
        z-index: ${9998 - index};
        cursor: pointer;
        animation: ${isHover ? 'fadeSlideIn' : 'slideInFromLeft'} 0.3s ease-out;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        border: 1px solid rgba(255, 255, 255, 0.2);
        letter-spacing: -0.1px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        white-space: nowrap;
      `;
      
      helpBubble.onmouseover = () => {
        helpBubble.style.transform = 'translateY(-1px) scale(1.02)';
        helpBubble.style.boxShadow = '0 6px 16px rgba(139, 69, 199, 0.4), 0 3px 8px rgba(0, 0, 0, 0.15)';
      };
      
      helpBubble.onmouseout = () => {
        helpBubble.style.transform = 'translateY(0) scale(1)';
        helpBubble.style.boxShadow = '0 4px 12px rgba(139, 69, 199, 0.3), 0 2px 6px rgba(0, 0, 0, 0.1)';
      };
      
      helpBubble.onclick = () => {
        openChatbot();
        removeAllHelpBubbles();
      };
      
      helpBannerContainer.appendChild(helpBubble);
      document.body.appendChild(helpBubble);
    }, delays[index]);
  });
  
  document.body.appendChild(helpBannerContainer);
  
  // Trigger shake animation when banner appears
  triggerShakeAttention();
  
  // Auto remove after 3 seconds (only if not hover banner)
  if (!isHover) {
    setTimeout(() => {
      if (document.getElementById('help-banner-container') && !helpBannerContainer.classList.contains('hover-banner')) {
        removeAllHelpBubbles();
      }
    }, 3000);
  }
  
  // Add resize handler to reposition bubbles
  const handleResize = () => {
    const bubbles = document.querySelectorAll('.help-bubble');
    bubbles.forEach((bubble, index) => {
      const screenWidth = window.innerWidth;
      let bottomPos, rightPos;
      
      if (screenWidth <= 320) {
        bottomPos = 70 + (index * 12);
        rightPos = 12;
      } else if (screenWidth <= 480) {
        bottomPos = 80 + (index * 13);
        rightPos = 15;
      } else if (screenWidth <= 768) {
        bottomPos = 95 + (index * 15);
        rightPos = 20;
      } else {
        bottomPos = 115 + (index * 25);
        rightPos = 25;
      }
      
      bubble.style.setProperty('bottom', `${bottomPos}px`, 'important');
      bubble.style.setProperty('right', `${rightPos}px`, 'important');
    });
  };
  
  // Remove existing listeners and add new one
  window.removeEventListener('resize', handleResize);
  window.addEventListener('resize', handleResize);
}

function startHelpBanner() {
  // Disabled - no longer showing help text bubbles, only shake animation
  return;
}

function removeAllHelpBubbles(includeHover = false) {
  const helpBubbles = document.querySelectorAll('.help-bubble');
  helpBubbles.forEach(bubble => {
    // Only remove hover bubbles if specifically requested
    if (includeHover || !bubble.classList.contains('hover-bubble')) {
      bubble.style.animation = 'slideOutToLeft 0.4s ease-in forwards';
      setTimeout(() => {
        if (document.body.contains(bubble)) {
          document.body.removeChild(bubble);
        }
      }, 400);
    }
  });
  
  const container = document.getElementById('help-banner-container');
  if (container && (includeHover || !container.classList.contains('hover-banner'))) {
    setTimeout(() => {
      if (document.body.contains(container)) {
        document.body.removeChild(container);
      }
    }, 500);
  }
  
  if (includeHover) {
    isHoverBannerVisible = false;
  }
}

function showHoverHelpBanner() {
  if (!isChatbotOpen && !isHoverBannerVisible) {
    isHoverBannerVisible = true;
    createHelpBanner(true);
  }
}

function hideHoverHelpBanner() {
  if (isHoverBannerVisible) {
    removeAllHelpBubbles(true); // Remove all bubbles including hover ones
  }
}

function stopHelpBanner() {
  if (helpBannerInterval) {
    clearInterval(helpBannerInterval);
    helpBannerInterval = null;
  }
  
  // Remove existing banners (including hover ones)
  removeAllHelpBubbles(true);
}

// Open chatbot function
function openChatbot() {
  isChatbotOpen = true;
  stopHelpBanner();
  
  openButton.classList.add('professional-disappear');
  
  setTimeout(() => {
    openButton.style.display = 'none';
    openButton.classList.remove('professional-disappear');
    chatbotBox.classList.add('professional-appear');
    chatbotBox.style.display = 'flex';
    
    // Add welcome messages on first open
    const chatbox = document.getElementById("chatbot-messages");
    if (!chatbox.innerHTML.trim()) {
      const welcomeMessages = [
        "¡Hola! Soy Bruno, el bot de GLOW.",
        "Solo para que lo sepas, al hablar con nosotros hoy, estás aceptando nuestra Política de Privacidad.",
        "Nuestra conversación será grabada con fines de entrenamiento y calidad. Si no quieres ser grabado, envíanos un correo aquí",
        "¿Sobre qué te gustaría saber más?"
      ];
      
      welcomeMessages.forEach((message, index) => {
        setTimeout(() => {
          const messageDiv = document.createElement('div');
          messageDiv.className = 'bot-message-container';
          messageDiv.style.cssText = 'display: flex; align-items: start; gap: 10px; margin-bottom: 10px; animation: slideIn 0.4s ease-out;';
          
          messageDiv.innerHTML = `
            <svg viewBox="0 0 200 200" style="width: 32px; height: 32px; flex-shrink: 0; border-radius: 50%; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
              <circle cx="100" cy="100" r="100" fill="#FF7B66"/>
              <path d="M 100,20 Q 105,50 100,80 Q 95,50 100,20" fill="#EE88FF"/>
              <path d="M 130,25 Q 125,55 110,75 Q 115,50 130,25" fill="#EE88FF"/>
              <path d="M 155,45 Q 140,65 120,75 Q 130,60 155,45" fill="#EE88FF"/>
              <path d="M 175,70 Q 150,75 125,80 Q 140,70 175,70" fill="#EE88FF"/>
              <path d="M 180,100 Q 150,100 125,100 Q 145,95 180,100" fill="#EE88FF"/>
              <path d="M 175,130 Q 150,125 125,120 Q 140,125 175,130" fill="#EE88FF"/>
              <path d="M 155,155 Q 140,135 120,125 Q 130,140 155,155" fill="#EE88FF"/>
              <path d="M 130,175 Q 125,145 110,125 Q 115,150 130,175" fill="#EE88FF"/>
              <path d="M 100,180 Q 105,150 100,120 Q 95,150 100,180" fill="#EE88FF"/>
              <path d="M 70,175 Q 75,145 90,125 Q 85,150 70,175" fill="#EE88FF"/>
              <path d="M 45,155 Q 60,135 80,125 Q 70,140 45,155" fill="#EE88FF"/>
              <path d="M 25,130 Q 50,125 75,120 Q 60,125 25,130" fill="#EE88FF"/>
              <path d="M 20,100 Q 50,100 75,100 Q 55,95 20,100" fill="#EE88FF"/>
              <path d="M 25,70 Q 50,75 75,80 Q 60,70 25,70" fill="#EE88FF"/>
              <path d="M 45,45 Q 60,65 80,75 Q 70,60 45,45" fill="#EE88FF"/>
              <path d="M 70,25 Q 75,55 90,75 Q 85,50 70,25" fill="#EE88FF"/>
              <circle cx="100" cy="100" r="45" fill="#EE88FF"/>
              <text x="100" y="120" font-family="Arial Black, sans-serif" font-size="48" font-weight="900" fill="black" text-anchor="middle">GLOW</text>
            </svg>
            <div class="welcome-message" style="
              background: #f3f4f6;
              border-radius: 14px 14px 14px 4px;
              padding: 10px 14px;
              max-width: 75%;
              word-wrap: break-word;
              overflow-wrap: break-word;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
            ">
              <p style="color: #1f2937; font-size: 13px; line-height: 1.4; margin: 0;">${message}</p>
            </div>
          `;
          
          chatbox.appendChild(messageDiv);
          chatbox.scrollTop = chatbox.scrollHeight;
          
          // Add quick reply buttons after the last message
          if (index === welcomeMessages.length - 1) {
            setTimeout(() => {
              showQuickReplyButtons();
            }, 300);
          }
        }, index * 800);
      });
    }
    
    // Setup resize handle
    setTimeout(() => {
      setupResizeHandle();
    }, 100);

  }, 300);
}

// Floating button with simple GLOW design
const openButton = document.createElement("div");
openButton.className = "glow-chatbot-button";
openButton.innerHTML = `
  <div style="
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #f472b6 0%, #fb923c 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 6px 16px rgba(244, 114, 182, 0.4);
    transition: all 0.3s ease;
  ">
    <span style="
      font-family: 'Arial Black', sans-serif;
      font-size: 16px;
      font-weight: 900;
      color: #000000;
      letter-spacing: 0.5px;
    ">GLOW</span>
  </div>
`;
openButton.style = `
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 70px;
  height: 70px;
  cursor: pointer;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: gentleFloat 3s ease-in-out infinite;
`;

// Hover effects for visual feedback only
openButton.onmouseover = () => {
  isMouseOverMila = true;
  const innerDiv = openButton.querySelector('div');
  if (innerDiv) {
    innerDiv.style.transform = "scale(1.1)";
    innerDiv.style.boxShadow = "0 8px 20px rgba(244, 114, 182, 0.5)";
  }
};

openButton.onmouseout = () => {
  isMouseOverMila = false;
  const innerDiv = openButton.querySelector('div');
  if (innerDiv) {
    innerDiv.style.transform = "scale(1)";
    innerDiv.style.boxShadow = "0 6px 16px rgba(244, 114, 182, 0.4)";
  }
};

// Add click functionality
openButton.onclick = () => {
  if (!isChatbotOpen) {
    openChatbot();
  }
};

// Add mobile touch support
openButton.ontouchstart = (e) => {
  // Trigger hover effect on touch start
  openButton.onmouseover();
};

openButton.ontouchend = (e) => {
  // Trigger mouse out effect
  openButton.onmouseout();
  // Open chatbot on touch end (like a click)
  setTimeout(() => {
    if (!isChatbotOpen) {
      openChatbot();
    }
  }, 100);
};

document.body.appendChild(openButton);

// Shake animation for floating button
function triggerShakeAttention() {
  if (!isChatbotOpen) {
    const currentAnimation = openButton.style.animation;
    openButton.style.animation = 'shakeAttention 0.6s ease-in-out';
    setTimeout(() => {
      openButton.style.animation = currentAnimation || 'gentleFloat 3s ease-in-out infinite';
    }, 600);
  }
}

// Start shake animation on page load
setTimeout(() => {
  setInterval(() => {
    if (!isChatbotOpen && !isMouseOverMila) {
      triggerShakeAttention();
    }
  }, 5000);
}, 3000);

// Handle input with word limit
document.getElementById("chatbot-input").addEventListener("keydown", (e) => {
  const input = e.target;
  if (input.disabled) {
    e.preventDefault();
    return;
  }
  if (e.key === "Enter") {
    e.preventDefault();
    const sendButton = document.getElementById('send-button');
    if (sendButton && !sendButton.disabled) {
      sendMessage();
    } else {
      updateSendButtonState();
      // Guide the user to missing fields (only when details are required)
      if (!hasSubmittedUserDetails) {
        const { nameEl, emailEl } = getUserDetailsElements();
        const nameVal = (nameEl && nameEl.value ? nameEl.value : '').trim();
        const emailVal = (emailEl && emailEl.value ? emailEl.value : '').trim();
        if (nameEl && !nameVal) nameEl.focus();
        else if (emailEl && !validateEmail(emailVal)) emailEl.focus();
      }
    }
  }
});

// Add word count validation
document.getElementById("chatbot-input").addEventListener("input", (e) => {
  const text = e.target.value;
  const words = text.trim().split(/\s+/).filter(word => word.length > 0);
  
  if (words.length > 150) {
    // Truncate to 150 words
    const truncated = words.slice(0, 150).join(' ');
    e.target.value = truncated;
    
    // Show warning
    showWordLimitWarning();
  }

  updateSendButtonState();
});

// Enable/disable Send based on name/email/message validity
const userNameInputEl = document.getElementById('chatbot-user-name');
const userEmailInputEl = document.getElementById('chatbot-user-email');
if (userNameInputEl) userNameInputEl.addEventListener('input', () => { updateSendButtonState(); });
if (userEmailInputEl) userEmailInputEl.addEventListener('input', () => { updateSendButtonState(); });
updateSendButtonState();

function showWordLimitWarning() {
  const input = document.getElementById("chatbot-input");
  const originalBorder = input.style.borderColor;
  
  input.style.borderColor = 'rgba(220, 38, 38, 0.5)';
  input.style.boxShadow = '0 0 0 3px rgba(220, 38, 38, 0.1)';
  
  // Show tooltip
  const tooltip = document.createElement('div');
  tooltip.innerHTML = 'Maximum 150 words allowed';
  tooltip.style = `
    position: absolute;
    bottom: 60px;
    left: 20px;
    background: rgba(220, 38, 38, 0.9);
    color: white;
    padding: 6px 10px;
    border-radius: 8px;
    font-size: 11px;
    z-index: 10000;
    animation: fadeSlideIn 0.3s ease-out;
  `;
  
  input.parentElement.style.position = 'relative';
  input.parentElement.appendChild(tooltip);
  
  setTimeout(() => {
    input.style.borderColor = originalBorder;
    input.style.boxShadow = 'none';
    if (tooltip.parentElement) {
      tooltip.parentElement.removeChild(tooltip);
    }
  }, 3000);
}

// Email validator
function validateEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').toLowerCase());
}

function getUserDetailsElements() {
  return {
    rowEl: document.getElementById('chatbot-user-row'),
    nameEl: document.getElementById('chatbot-user-name'),
    emailEl: document.getElementById('chatbot-user-email'),
    errorEl: document.getElementById('chatbot-user-error')
  };
}

function clearUserDetailsError() {
  const { errorEl } = getUserDetailsElements();
  if (!errorEl) return;
  errorEl.textContent = '';
  errorEl.style.display = 'none';
}

function showUserDetailsError(message) {
  const { errorEl } = getUserDetailsElements();
  if (!errorEl) return;
  errorEl.textContent = message || '';
  errorEl.style.display = message ? 'block' : 'none';
}

function getUserDetailsFromInputs() {
  const { nameEl, emailEl } = getUserDetailsElements();
  const name = (nameEl && nameEl.value ? nameEl.value : '').trim();
  const email = (emailEl && emailEl.value ? emailEl.value : '').trim();
  return { name, email };
}

function updateSendButtonState() {
  const inputEl = document.getElementById('chatbot-input');
  const sendButtonEl = document.getElementById('send-button');
  if (!inputEl || !sendButtonEl) return;

  const msg = (inputEl.value || '').trim();
  const hasMessage = msg.length > 0;

  let canSend = hasMessage;

  // Gate on name/email until we have details
  if (!hasSubmittedUserDetails) {
    const { name, email } = getUserDetailsFromInputs();
    const hasName = !!name;
    const hasEmail = !!email;
    const emailOk = hasEmail && validateEmail(email);
    canSend = canSend && hasName && emailOk;

    // Show helpful inline guidance once the user starts typing anything
    if ((hasMessage || hasName || hasEmail) && (!hasName || !emailOk)) {
      if (!hasName) showUserDetailsError('Please enter your name to continue.');
      else if (!hasEmail) showUserDetailsError('Please enter your email to continue.');
      else if (!emailOk) showUserDetailsError('Please enter a valid email.');
    } else {
      clearUserDetailsError();
    }
  } else {
    clearUserDetailsError();
  }

  sendButtonEl.disabled = !canSend;
  if (canSend) {
    sendButtonEl.style.background = 'linear-gradient(to right, #f472b6, #fb923c)';
    sendButtonEl.style.color = 'white';
    sendButtonEl.style.cursor = 'pointer';
  } else {
    sendButtonEl.style.background = '#e5e7eb';
    sendButtonEl.style.color = '#9ca3af';
    sendButtonEl.style.cursor = 'not-allowed';
  }
}

function sendMessage() {
  const input = document.getElementById("chatbot-input");
  const sendButton = document.getElementById("send-button");
  const msg = (input && input.value ? input.value : '').trim();
  if (!msg) {
    updateSendButtonState();
    return;
  }

  // If user details are required, validate + capture them before sending
  let extraSystemContext = '';
  if (!hasSubmittedUserDetails) {
    const { name, email } = getUserDetailsFromInputs();
    const hasName = !!name;
    const hasEmail = !!email;
    const emailOk = hasEmail && validateEmail(email);

    if (!hasName || !emailOk) {
      updateSendButtonState();
      return;
    }

    // Capture details for backend payload
    userDetails = { name, email };
    hasSubmittedUserDetails = true;

    // One-time context to help the assistant personalize (backend contract unchanged)
    extraSystemContext = name ? `For context, the customer's first name is ${name}.` : '';

    // Persist for the session
    try {
      sessionStorage.setItem('glow_user_details', JSON.stringify({ name, email }));
    } catch (_) { /* no-op */ }

    // Hide details UI after capture
    const { rowEl } = getUserDetailsElements();
    if (rowEl) rowEl.style.display = 'none';
    clearUserDetailsError();
  }

  // Disable input(s) and send button during processing
  const { nameEl, emailEl } = getUserDetailsElements();
  if (nameEl) { nameEl.disabled = true; nameEl.style.opacity = '0.6'; }
  if (emailEl) { emailEl.disabled = true; emailEl.style.opacity = '0.6'; }

  input.disabled = true;
  sendButton.disabled = true;
  input.style.opacity = '0.6';
  sendButton.style.opacity = '0.6';
  sendButton.style.cursor = 'not-allowed';

  const chatbox = document.getElementById("chatbot-messages");
  const userMsgContainerId = 'user-msg-' + Date.now();
  
  // User message styling
  chatbox.innerHTML += `
    <div id="${userMsgContainerId}" style="
      display: flex;
      justify-content: flex-end;
      margin-bottom: 10px;
    ">
      <div class="user-message" style="
        background: linear-gradient(to right, #f472b6, #fb923c);
        color: white;
        padding: 10px 14px;
        border-radius: 14px 14px 4px 14px;
        max-width: 80%;
        font-size: 13px;
        line-height: 1.4;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        word-wrap: break-word;
        overflow-wrap: break-word;
      ">
        ${msg}
      </div>
    </div>
  `;
  input.value = "";

  // Show typing indicator with animated dots (for subsequent messages)
  const typingId = 'typing-' + Date.now();
  chatbox.innerHTML += `
    <div id="${typingId}" style="
      display: flex !important;
      justify-content: flex-start !important;
      margin-bottom: 10px !important;
    ">
      <div style="
        background: rgba(248, 250, 252, 0.8) !important;
        backdrop-filter: blur(5px) !important;
        color: rgba(100, 116, 139, 0.8) !important;
        padding: 12px 16px !important;
        border-radius: 16px 16px 16px 4px !important;
        max-width: 75% !important;
        font-size: 14px !important;
        display: flex !important;
        align-items: center !important;
        gap: 8px !important;
        border: 1px solid rgba(255, 255, 255, 0.2) !important;
      ">
        <div style="
          display: flex !important;
          gap: 4px !important;
          align-items: center !important;
        ">
          <div class="thinking-dot" style="width: 5px !important; height: 5px !important; background: rgba(139, 69, 199, 0.7) !important; border-radius: 50% !important; display: block !important; animation: thinkingDots 1.5s infinite !important;"></div>
          <div class="thinking-dot" style="width: 5px !important; height: 5px !important; background: rgba(139, 69, 199, 0.7) !important; border-radius: 50% !important; display: block !important; animation: thinkingDots 1.5s infinite 0.3s !important;"></div>
          <div class="thinking-dot" style="width: 5px !important; height: 5px !important; background: rgba(139, 69, 199, 0.7) !important; border-radius: 50% !important; display: block !important; animation: thinkingDots 1.5s infinite 0.6s !important;"></div>
        </div>
        <span>Glow bot is thinking...</span>
      </div>
    </div>
  `;

  // Add thinking dots animation
  if (!document.getElementById('thinking-dots-style')) {
    const thinkingStyle = document.createElement('style');
    thinkingStyle.id = 'thinking-dots-style';
    thinkingStyle.textContent = `
      @keyframes thinkingDots {
        0%, 80%, 100% { 
          transform: translateY(0); 
          opacity: 0.7;
        }
        40% { 
          transform: translateY(-3px); 
          opacity: 1;
        }
      }
      
      @keyframes bounce {
        0%, 60%, 100% { transform: translateY(0); }
        30% { transform: translateY(-10px); }
      }
    `;
    document.head.appendChild(thinkingStyle);
  }

  chatbox.scrollTop = chatbox.scrollHeight;

  // Remove typing indicator and create streaming container
  document.getElementById(typingId).remove();
  
  // Create streaming message container
  const streamingId = 'streaming-' + Date.now();
  chatbox.innerHTML += createStreamingContainer(streamingId);
  chatbox.scrollTop = chatbox.scrollHeight;
  
  // Add user message to conversation history
  conversationHistory.push({role: "user", content: msg});
  
  // Call Lambda function for AI response with streaming
  callLambdaFunction(msg, extraSystemContext)
    .then(data => {
      const responseText = (data && (data.responseText || data.response)) || '';
      if (data && data.conversationId) {
        conversationId = data.conversationId;
      }
      // Format the response
      const formattedResponse = formatAIResponse(responseText);
      
      // Add AI response to conversation history
      conversationHistory.push({role: "assistant", content: responseText});
      
      // Keep only last 10 messages for performance
      if (conversationHistory.length > 10) {
        conversationHistory = conversationHistory.slice(-10);
      }
      
      // Stream the response with typing effect
      streamResponse(streamingId, formattedResponse, false, data);
    })
    .catch(error => {
      const errorMessage = formatAIResponse("I apologize, but I'm having trouble connecting right now. Please try again in a moment! 🌸");
      streamResponse(streamingId, errorMessage, true, null);
      console.error('Error calling Lambda function:', error);
    });
}

// Function to call Lambda function via API Gateway
async function callLambdaFunction(message, systemContext = '') {
  try {
    const combinedSystemContext = (BASE_SYSTEM_CONTEXT + (systemContext ? (' ' + systemContext) : '')).trim();
    const response = await fetch(API_CONFIG.endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        action: 'chat',
        message: message,
        history: conversationHistory,
        user: userDetails,
        origin: 'website',
        conversationId: conversationId,
        systemContext: combinedSystemContext
      }),
      signal: AbortSignal.timeout(API_CONFIG.timeout)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    if (!data.success) {
      throw new Error(data.error || 'Unknown error occurred');
    }

    return {
      responseText: data.response,
      messageId: data.messageId || null,
      conversationId: data.conversationId || conversationId,
      // New flat backend contract (always present, with null defaults)
      product_url_1: data.product_url_1 || null,
      product_url_2: data.product_url_2 || null,
      image_url_1: data.image_url_1 || null,
      image_url_2: data.image_url_2 || null,
      end_of_conversation: !!data.end_of_conversation
    };
  } catch (error) {
    console.error('Lambda function call failed:', error);
    
    // Fallback to local wellness response
    return {
      responseText: getFallbackWellnessResponse(message),
      messageId: null,
      conversationId: conversationId,
      product_url_1: null,
      product_url_2: null,
      image_url_1: null,
      image_url_2: null,
      end_of_conversation: false
    };
  }
}

// Function to format AI response text with comprehensive formatting
function formatAIResponse(text) {
  if (!text) return '';
  
  let formatted = String(text);

  // Normalize newlines early
  formatted = formatted.replace(/\r\n/g, '\n');

  // Remove pipe characters that break formatting (backend sometimes uses pipes as separators)
  // Covers: | (ASCII), ｜ (fullwidth), ¦ (broken bar), │┃ (box drawing)
  formatted = formatted.replace(/[|｜¦│┃]/g, '');
  // Also remove HTML-encoded pipe entities
  formatted = formatted.replace(/&#124;|&#x7c;|&#x7C;|&vert;|&VerticalLine;/gi, '');

  // Clean up common malformed markdown like "Descripción**:" / "Descripción:**"
  formatted = formatted.replace(/\*\*:/g, ':');
  formatted = formatted.replace(/:\*\*/g, ':');
  // Remove lines that are just a dash (often appears in product streams)
  formatted = formatted.replace(/^\s*[-–—]\s*$/gm, '');
  
  // Handle markdown-style links [text](url):
  // Product widgets are shown separately, so we strip product name links
  // Only convert explicit "Ver producto" links to clickable links
  formatted = formatted.replace(/\[([^\]]+)\]\s*\(([^)]+)\)/g, function(match, text, url) {
    const textTrim = String(text || '').trim();
    let cleanUrl = String(url || '').trim();
    
    // If no valid URL, just return the text
    if (!cleanUrl || !/^https?:\/\//i.test(cleanUrl)) {
      return textTrim;
    }
    
    // Clean the URL
    cleanUrl = cleanUrl.replace(/^<|>$/g, '').replace(/^"+|"+$/g, '');
    cleanUrl = cleanUrl.replace(/[.,;:!?)\]]+$/, '');
    cleanUrl = cleanUrl.split(/\s+/)[0];
    
    // Only make "Ver producto" / "Aquí" / "Here" clickable
    // Product names should just appear as plain text (widgets show the links)
    if (/^ver\s+(el\s+)?producto$/i.test(textTrim) || 
        textTrim.toLowerCase() === 'aquí' || 
        textTrim.toLowerCase() === 'here' ||
        textTrim.toLowerCase() === 'click here') {
      return '<a class="glow-link" href="' + cleanUrl + '" target="_blank" rel="noopener noreferrer">Ver producto</a>';
    }
    
    // For product names or other text, strip the link and keep just the text
    return textTrim;
  });
  
  // Handle plain URLs (but avoid those already in href)
  formatted = formatted.replace(/(^|[^"'])https?:\/\/[^\s<>"]+/g, function(match, prefix) {
    let url = match.replace(prefix, '');
    let cleanUrl = url;
    let trailingPunct = '';
    if (/[.,;:!?)\]]+$/.test(url)) {
      const punctMatch = url.match(/([.,;:!?)\]]+)$/);
      trailingPunct = punctMatch[0];
      cleanUrl = url.substring(0, url.length - trailingPunct.length);
    }
    cleanUrl = String(cleanUrl || '').trim().replace(/^<|>$/g, '').replace(/^"+|"+$/g, '');
    cleanUrl = cleanUrl.split(/\s+/)[0];
    return prefix + '<a class="glow-link" href="' + cleanUrl + '" target="_blank" rel="noopener noreferrer">Ver producto</a>' + trailingPunct;
  });
  
  // Convert **bold** to <strong>
  formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  
  // Convert *italic* to <em>
  formatted = formatted.replace(/\*([^*\n]+)\*/g, '<em>$1</em>');
  
  // Handle numbered lists (1. 2. 3.) - simplified format
  formatted = formatted.replace(/^(\d+)\.\s+(.+)$/gm, '<div class="numbered-list-item"><span class="list-number">$1.</span> <span>$2</span></div>');
  
  // Handle bullet points starting with - (product benefits) - simplified format
  formatted = formatted.replace(/^[-–—]\s+(.+)$/gm, '<div class="benefit-item">• $1</div>');
  
  // Handle usage instructions (Uso: or Use:)
  formatted = formatted.replace(/(Uso?:|Use:|Usage:)\s(.+)/gi, '<div class="usage-instruction"><strong>$1</strong> $2</div>');
  
  // Handle specifications (Especificaciones: or Specifications:)
  formatted = formatted.replace(/(Especificaciones?:|Specifications?:)\s(.+)/gi, '<div class="usage-instruction"><strong>$1</strong> $2</div>');
  
  // Convert line breaks to <br> (avoid injecting <p> tags, which was breaking HTML and product formatting)
  formatted = formatted.replace(/\n\s*\n/g, '<br><br>');
  formatted = formatted.replace(/\n/g, '<br>');
  // Collapse excessive breaks
  formatted = formatted.replace(/(<br>\s*){3,}/g, '<br><br>');
  // Trim leading/trailing breaks
  formatted = formatted.replace(/^(<br>\s*)+|(<br>\s*)+$/g, '');
  
  return formatted;
}

// Function to create streaming container for typing animation
function createStreamingContainer(messageId) {
  return `
    <div id="${messageId}" style="
      display: flex;
      align-items: start;
      gap: 10px;
      margin-bottom: 10px;
    ">
      <svg viewBox="0 0 200 200" style="width: 32px; height: 32px; flex-shrink: 0; border-radius: 50%; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
        <circle cx="100" cy="100" r="100" fill="#FF7B66"/>
        <path d="M 100,20 Q 105,50 100,80 Q 95,50 100,20" fill="#EE88FF"/>
        <path d="M 130,25 Q 125,55 110,75 Q 115,50 130,25" fill="#EE88FF"/>
        <path d="M 155,45 Q 140,65 120,75 Q 130,60 155,45" fill="#EE88FF"/>
        <path d="M 175,70 Q 150,75 125,80 Q 140,70 175,70" fill="#EE88FF"/>
        <path d="M 180,100 Q 150,100 125,100 Q 145,95 180,100" fill="#EE88FF"/>
        <path d="M 175,130 Q 150,125 125,120 Q 140,125 175,130" fill="#EE88FF"/>
        <path d="M 155,155 Q 140,135 120,125 Q 130,140 155,155" fill="#EE88FF"/>
        <path d="M 130,175 Q 125,145 110,125 Q 115,150 130,175" fill="#EE88FF"/>
        <path d="M 100,180 Q 105,150 100,120 Q 95,150 100,180" fill="#EE88FF"/>
        <path d="M 70,175 Q 75,145 90,125 Q 85,150 70,175" fill="#EE88FF"/>
        <path d="M 45,155 Q 60,135 80,125 Q 70,140 45,155" fill="#EE88FF"/>
        <path d="M 25,130 Q 50,125 75,120 Q 60,125 25,130" fill="#EE88FF"/>
        <path d="M 20,100 Q 50,100 75,100 Q 55,95 20,100" fill="#EE88FF"/>
        <path d="M 25,70 Q 50,75 75,80 Q 60,70 25,70" fill="#EE88FF"/>
        <path d="M 45,45 Q 60,65 80,75 Q 70,60 45,45" fill="#EE88FF"/>
        <path d="M 70,25 Q 75,55 90,75 Q 85,50 70,25" fill="#EE88FF"/>
        <circle cx="100" cy="100" r="45" fill="#EE88FF"/>
        <text x="100" y="120" font-family="Arial Black, sans-serif" font-size="48" font-weight="900" fill="black" text-anchor="middle">GLOW</text>
      </svg>
      <div class="ai-message streaming" style="
        background: #f3f4f6;
        color: #1f2937;
        padding: 10px 14px;
        border-radius: 14px 14px 14px 4px;
        max-width: 82%;
        font-size: 13px;
        line-height: 1.4;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        word-wrap: break-word;
        overflow-wrap: break-word;
      ">
        <div class="streaming-content"></div>
        <div class="streaming-dots" style="
          display: inline-flex !important;
          gap: 2px !important;
          align-items: center !important;
          margin-left: 4px !important;
        ">
          <div class="thinking-dot" style="width: 3px !important; height: 3px !important; background: #9ca3af !important; border-radius: 50% !important; display: block !important; animation: thinkingDots 1.5s infinite !important;"></div>
          <div class="thinking-dot" style="width: 3px !important; height: 3px !important; background: #9ca3af !important; border-radius: 50% !important; display: block !important; animation: thinkingDots 1.5s infinite 0.3s !important;"></div>
          <div class="thinking-dot" style="width: 3px !important; height: 3px !important; background: #9ca3af !important; border-radius: 50% !important; display: block !important; animation: thinkingDots 1.5s infinite 0.6s !important;"></div>
        </div>
      </div>
    </div>
  `;
}

function renderProductCards(aiMessageDiv, productCards) {
  try {
    if (!aiMessageDiv) return;
    if (!Array.isArray(productCards) || productCards.length === 0) return;
    // Prevent duplicates
    if (aiMessageDiv.querySelector('.product-cards')) return;
    
    const container = document.createElement('div');
    container.className = 'product-cards';
    
    productCards.slice(0, 3).forEach((card) => {
      if (!card || !card.url) return;
      const a = document.createElement('a');
      a.className = 'product-card';
      a.href = card.url;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      
      const imgWrap = document.createElement('div');
      imgWrap.className = 'product-card-img';
      if (card.imageUrl) {
        const img = document.createElement('img');
        img.src = card.imageUrl;
        img.alt = card.title || 'Product';
        img.loading = 'lazy';
        imgWrap.appendChild(img);
      } else {
        imgWrap.textContent = '🛍️';
      }
      
      const textWrap = document.createElement('div');
      const titleEl = document.createElement('div');
      titleEl.className = 'product-card-title';
      titleEl.textContent = card.title || 'View product';
      const subEl = document.createElement('div');
      subEl.className = 'product-card-subtitle';
      subEl.textContent = card.subtitle || 'Tap to view';
      textWrap.appendChild(titleEl);
      textWrap.appendChild(subEl);
      
      a.appendChild(imgWrap);
      a.appendChild(textWrap);
      container.appendChild(a);
    });
    
    if (container.childElementCount === 0) return;
    aiMessageDiv.appendChild(container);
  } catch (_) { /* no-op */ }
}

// Render 2 product widgets from the new flat backend contract:
// { product_url_1, product_url_2, image_url_1, image_url_2 }
function renderFlatProductWidgets(messageContainer, payload = {}) {
  try {
    if (!messageContainer) return;
    // Prevent duplicates only for THIS message (allow product cards for later messages too)
    const nextEl = messageContainer.nextElementSibling;
    if (nextEl && nextEl.classList && nextEl.classList.contains('product-cards-wrapper')) return;

    const url1 = payload && payload.product_url_1 ? String(payload.product_url_1).trim() : '';
    const url2 = payload && payload.product_url_2 ? String(payload.product_url_2).trim() : '';
    const img1 = payload && payload.image_url_1 ? String(payload.image_url_1).trim() : '';
    const img2 = payload && payload.image_url_2 ? String(payload.image_url_2).trim() : '';

    const urls = [url1, url2].filter(Boolean);
    const imgs = [img1, img2];
    if (urls.length === 0) return;

    // Create wrapper that will be placed AFTER the message container
    const wrapper = document.createElement('div');
    wrapper.className = 'product-cards-wrapper';
    wrapper.style.display = 'flex';
    wrapper.style.justifyContent = 'flex-start';
    wrapper.style.marginBottom = '12px';
    wrapper.style.marginLeft = '42px';
    wrapper.style.width = 'calc(100% - 42px)';

    const container = document.createElement('div');
    container.className = 'product-cards';
    container.style.display = 'grid';
    container.style.gridTemplateColumns = urls.length > 1 ? 'repeat(2, 1fr)' : '1fr';
    container.style.gap = '12px';
    container.style.maxWidth = '100%';

    urls.slice(0, 2).forEach((url, idx) => {
      const card = document.createElement('div');
      card.className = 'product-card-new';
      card.style.borderRadius = '16px';
      card.style.background = 'rgba(255, 255, 255, 0.9)';
      card.style.border = '1px solid rgba(244, 114, 182, 0.2)';
      card.style.boxShadow = '0 4px 12px rgba(244, 114, 182, 0.15), 0 2px 6px rgba(0,0,0,0.08)';
      card.style.overflow = 'hidden';
      card.style.display = 'flex';
      card.style.flexDirection = 'column';
      card.style.transition = 'all 0.3s ease';

      const imgWrap = document.createElement('div');
      imgWrap.style.width = '100%';
      imgWrap.style.aspectRatio = '1 / 1';
      imgWrap.style.background = 'linear-gradient(135deg, rgba(244, 114, 182, 0.08) 0%, rgba(251, 146, 60, 0.05) 100%)';
      imgWrap.style.display = 'flex';
      imgWrap.style.alignItems = 'center';
      imgWrap.style.justifyContent = 'center';
      imgWrap.style.overflow = 'hidden';
      imgWrap.style.position = 'relative';

      const imgUrl = imgs[idx] || '';
      if (imgUrl) {
        const img = document.createElement('img');
        img.src = imgUrl;
        img.alt = 'Product image';
        img.loading = 'lazy';
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'cover';
        imgWrap.appendChild(img);
      } else {
        imgWrap.style.fontSize = '32px';
        imgWrap.textContent = '🛍️';
      }

      const body = document.createElement('div');
      body.style.padding = '10px';
      body.style.display = 'flex';
      body.style.flexDirection = 'column';

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-buy-btn';
      btn.textContent = 'Buy';
      btn.style.border = 'none';
      btn.style.borderRadius = '12px';
      btn.style.padding = '12px 16px';
      btn.style.cursor = 'pointer';
      btn.style.color = 'white';
      btn.style.fontSize = '14px';
      btn.style.fontWeight = '600';
      btn.style.background = 'linear-gradient(to right, #f472b6, #fb923c)';
      btn.style.transition = 'all 0.2s ease';
      btn.style.boxShadow = '0 2px 8px rgba(244, 114, 182, 0.3)';
      btn.style.width = '100%';
      
      btn.addEventListener('mouseover', () => {
        btn.style.transform = 'translateY(-2px)';
        btn.style.boxShadow = '0 4px 12px rgba(244, 114, 182, 0.4)';
      });
      
      btn.addEventListener('mouseout', () => {
        btn.style.transform = 'translateY(0)';
        btn.style.boxShadow = '0 2px 8px rgba(244, 114, 182, 0.3)';
      });
      
      btn.addEventListener('click', () => {
        try { window.open(url, '_blank', 'noopener,noreferrer'); } catch (_) { /* no-op */ }
      });

      body.appendChild(btn);

      card.appendChild(imgWrap);
      card.appendChild(body);
      
      // Add hover effect to card
      card.addEventListener('mouseover', () => {
        card.style.transform = 'translateY(-4px)';
        card.style.boxShadow = '0 8px 20px rgba(244, 114, 182, 0.2), 0 4px 12px rgba(0,0,0,0.1)';
      });
      
      card.addEventListener('mouseout', () => {
        card.style.transform = 'translateY(0)';
        card.style.boxShadow = '0 4px 12px rgba(244, 114, 182, 0.15), 0 2px 6px rgba(0,0,0,0.08)';
      });

      container.appendChild(card);
    });

    wrapper.appendChild(container);
    try {
      wrapper.setAttribute('data-for-message', String(messageContainer.id || ''));
    } catch (_) { /* no-op */ }
    
    // Insert AFTER the message container, not inside it
    if (messageContainer.parentElement && messageContainer.nextSibling) {
      messageContainer.parentElement.insertBefore(wrapper, messageContainer.nextSibling);
    } else if (messageContainer.parentElement) {
      messageContainer.parentElement.appendChild(wrapper);
    }
  } catch (_) { /* no-op */ }
}

function getRatingStorageKey() {
  return conversationId ? `glow_rating_submitted_${conversationId}` : 'glow_rating_submitted';
}

function hasSubmittedRating() {
  try {
    return sessionStorage.getItem(getRatingStorageKey()) === 'true';
  } catch (_) {
    return false;
  }
}

function markRatingSubmitted() {
  try {
    sessionStorage.setItem(getRatingStorageKey(), 'true');
  } catch (_) { /* no-op */ }
}

async function submitStarRating(stars, reason = '') {
  try {
    await fetch(API_CONFIG.endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        action: 'rating',
        stars: stars,
        conversationId: conversationId,
        origin: 'website',
        user: userDetails,
        reason: reason
      }),
      signal: AbortSignal.timeout(API_CONFIG.timeout)
    });
    markRatingSubmitted();
    return true;
  } catch (err) {
    console.warn('Rating send failed', err);
    return false;
  }
}

function renderStarRatingWidget(aiMessageDiv, reason = '') {
  try {
    if (!aiMessageDiv) return;
    if (hasSubmittedRating()) return;
    // Prevent duplicates
    if (aiMessageDiv.querySelector('.star-rating')) return;
    
    const wrapper = document.createElement('div');
    wrapper.className = 'star-rating';
    
    const row = document.createElement('div');
    row.className = 'star-row';
    
    const hint = document.createElement('div');
    hint.className = 'star-hint';
    hint.textContent = '';
    
    const setActive = (val) => {
      const starsEls = row.querySelectorAll('.star');
      starsEls.forEach((el) => {
        const n = parseInt(el.getAttribute('data-star') || '0', 10);
        if (n <= val) el.classList.add('active');
        else el.classList.remove('active');
      });
    };
    
    const disable = () => {
      const starsEls = row.querySelectorAll('.star');
      starsEls.forEach((el) => {
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.7';
      });
    };
    
    for (let i = 1; i <= 5; i++) {
      const star = document.createElement('div');
      star.className = 'star';
      star.setAttribute('data-star', String(i));
      star.textContent = '★';
      star.addEventListener('mouseenter', () => setActive(i));
      star.addEventListener('click', async () => {
        setActive(i);
        disable();
        hint.textContent = 'Thanks! Saving your rating...';
        const ok = await submitStarRating(i, reason);
        hint.textContent = ok ? 'Thanks for your feedback!' : 'Sorry—could not save your rating. Please try again later.';
      });
      row.appendChild(star);
    }
    
    wrapper.appendChild(row);
    wrapper.appendChild(hint);
    aiMessageDiv.appendChild(wrapper);
  } catch (_) { /* no-op */ }
}
// Order tracking widget + idle “quick rating” prompt removed.
// Order tracking is handled conversationally by the backend PAO agent.

// Feedback UI removed (thumbs up/down)

// Function to stream response with realistic typing effect
async function streamResponse(messageId, formattedText, isError = false, payload = null) {
  const messageElement = document.getElementById(messageId);
  if (!messageElement) return;
  
  const contentElement = messageElement.querySelector('.streaming-content');
  const dotsElement = messageElement.querySelector('.streaming-dots');
  const chatbox = document.getElementById("chatbot-messages");
  
  // If error, change styling
  if (isError) {
    const messageDiv = messageElement.querySelector('.ai-message');
    messageDiv.style.borderLeft = '3px solid rgba(220, 38, 38, 0.4)';
    messageDiv.style.color = 'rgba(220, 38, 38, 0.9)';
  }
  
  // Split text into chunks for streaming - handle both plain text and HTML
  const chunks = createStreamingChunks(formattedText);
  let displayedContent = '';
  
  // Stream chunks with realistic typing speed
  for (let i = 0; i < chunks.length; i++) {
    displayedContent += chunks[i];
    contentElement.innerHTML = displayedContent;
    
    // Auto-scroll to keep the message visible
    chatbox.scrollTop = chatbox.scrollHeight;
    
    // Variable typing speed based on content type
    const delay = calculateTypingDelay(chunks[i]);
    await new Promise(resolve => setTimeout(resolve, delay));
  }
  
  // Remove dots and streaming class
  if (dotsElement) dotsElement.remove();
  const aiDiv = messageElement.querySelector('.ai-message');
  aiDiv.classList.remove('streaming');

  // Render product widgets OUTSIDE the message bubble (pass the message container, not the inner div)
  if (payload && (payload.product_url_1 || payload.product_url_2)) {
    renderFlatProductWidgets(messageElement, payload);
  }

  // Render star rating widget (inside the bubble for ratings)
  if (payload && payload.end_of_conversation) {
    renderStarRatingWidget(aiDiv, 'conversation_finished');
  }
  
  // Final scroll
  chatbox.scrollTop = chatbox.scrollHeight;
  
  // Re-enable input and send button after response is complete
  const inputEl = document.getElementById('chatbot-input');
  if (inputEl) {
    inputEl.disabled = false;
    inputEl.style.opacity = '1';
    inputEl.focus();
  }

  const { nameEl, emailEl } = getUserDetailsElements();
  if (nameEl) { nameEl.disabled = false; nameEl.style.opacity = '1'; }
  if (emailEl) { emailEl.disabled = false; emailEl.style.opacity = '1'; }

  updateSendButtonState();
}

// Function to create streaming chunks from formatted text
function createStreamingChunks(formattedText) {
  const chunks = [];
  let currentChunk = '';
  let inTag = false;
  let tagStack = [];
  
  for (let i = 0; i < formattedText.length; i++) {
    const char = formattedText[i];
    
    if (char === '<') {
      inTag = true;
      currentChunk += char;
    } else if (char === '>') {
      inTag = false;
      currentChunk += char;
      
      // Check if it's a closing tag
      const tagMatch = currentChunk.match(/<\/?\w+[^>]*>$/);
      if (tagMatch) {
        const tag = tagMatch[0];
        if (tag.startsWith('</')) {
          // Closing tag - don't create chunk yet
        } else {
          // Opening tag - create chunk if we have content
          if (currentChunk.trim()) {
            chunks.push(currentChunk);
            currentChunk = '';
          }
        }
      }
    } else if (!inTag) {
      currentChunk += char;
      
      // Create chunks at word boundaries or after punctuation
      if ((char === ' ' || char === '.' || char === '!' || char === '?') && currentChunk.length > 15) {
        chunks.push(currentChunk);
        currentChunk = '';
      }
    } else {
      currentChunk += char;
    }
  }
  
  // Add remaining content
  if (currentChunk.trim()) {
    chunks.push(currentChunk);
  }
  
  // Filter out empty chunks
  return chunks.filter(chunk => chunk.trim().length > 0);
}

// Function to calculate typing delay based on content
function calculateTypingDelay(chunk) {
  // Faster for HTML tags
  if (chunk.includes('<') || chunk.includes('>')) {
    return 20;
  }
  
  // Slower for punctuation
  if (chunk.includes('.') || chunk.includes('!') || chunk.includes('?')) {
    return 100;
  }
  
  // Normal speed for regular text
  const baseDelay = 30;
  const lengthFactor = Math.min(chunk.length * 2, 50);
  return baseDelay + lengthFactor;
}

// Fallback function when API is unavailable
function getFallbackWellnessResponse(userMessage) {
  const msg = userMessage.toLowerCase();
  
  if (msg.includes('hello') || msg.includes('hi') || msg.includes('hey')) {
    return "Hello there! 🌸 I'm having some connection issues, but I'm still here to help with your wellness journey!";
  }
  
  return "I'm experiencing some technical difficulties, but your wellness matters! 💚 Please try again in a moment, and remember to be kind to yourself today.";
}

// Legacy getWellnessResponse function removed - now using Lambda function API calls